// ==========================================
// CONSTANTES GLOBALES (Regalos y Aportes)
// ==========================================
const TEXTO_PREMIUM  = "Obsequio de Cortesía";
const TEXTO_SORPRESA = "Obsequio Sorpresa";

const ID_SORPRESA_VARIANT = 47335563624675; 
const ID_PREMIUM_CHECK = 9096597373155; 

// !!! REEMPLAZA ESTOS IDs POR LOS DE TUS VARIANTES DE APORTE EN SHOPIFY !!!
const IDS_APORTE = {
    2000: 49733344100579,
    5000: 49706402087139,
    10000: 49706402119907,
    20000: 49706402152675,
    50000: 49733344133347
};

window.itemsOcultosReales = parseInt(sessionStorage.getItem('opus_ocultos_cache')) || 0;
let montoAporteSeleccionado = 0; // Por defecto arranca en 0 (No, gracias)
let globalUnoPorCiento = 0;
let globalTotalFundacion = 0;
let ultimoSubtotalAporte = -1;

// --- 1. LÓGICA DE DATOS (REGALOS) ---
async function sincronizarConBackend() {
    try {
        const res = await fetch(window.Shopify.routes.root + 'cart.js');
        const cart = await res.json();
        
        let ocultos = 0;
        let premiumsEnCarrito = [];
        let nivel3Alcanzado = false;

        cart.items.forEach(item => {
            if (item.variant_id === ID_PREMIUM_CHECK || item.product_id === ID_PREMIUM_CHECK || item.title.includes(TEXTO_PREMIUM)) {
                premiumsEnCarrito.push(item);
            }
        });

        if (premiumsEnCarrito.length > 0) {
            nivel3Alcanzado = true;
            let indexToKeep = premiumsEnCarrito.findIndex(item => item.price === 0);
            if (indexToKeep === -1) indexToKeep = 0;

            premiumsEnCarrito.forEach((item, index) => {
                if (index !== indexToKeep) ocultos += item.quantity;
            });
        }

        cart.items.forEach(item => {
            if (item.variant_id === ID_SORPRESA_VARIANT || item.title.includes(TEXTO_SORPRESA)) {
                if (nivel3Alcanzado) ocultos += item.quantity;
            }
        });

        window.itemsOcultosReales = ocultos;
        sessionStorage.setItem('opus_ocultos_cache', ocultos); 
        corregirContadores(ocultos);
        
    } catch (error) {
        console.log("Error sincronizando cart:", error);
    }
}

// --- 2. LÓGICA VISUAL (REGALOS) ---
function gestionarVisibilidadRegalos() {
    const items = Array.from(document.querySelectorAll('.cd-product-item, .opus-cart-item, .cart-item, .drawer__cart-item, [class*="cart-item"]'));
    if (items.length === 0) return;

    let nivel3Alcanzado = false;

    const premiums = items.filter(item => {
        const tieneBotonBorrar = item.querySelector('.cd-product-item-delete, .opus-remove, .icon-delete, [href*="quantity=0"], svg');
        return item.innerText.includes(TEXTO_PREMIUM) && tieneBotonBorrar;
    });

    if (premiums.length > 0) {
        nivel3Alcanzado = true;
        let indexToKeep = 0; 
        for (let i = 0; i < premiums.length; i++) {
            const texto = premiums[i].innerText.toUpperCase();
            if (texto.includes('$0') || texto.includes('AHORRA') || texto.includes('GRATIS')) {
                indexToKeep = i; break; 
            }
        }

        premiums.forEach((item, index) => {
            if (index !== indexToKeep) {
                if (item.style.display !== 'none') {
                    item.style.cssText = `display: none !important; position: absolute !important; opacity: 0 !important; height: 0 !important; margin: 0 !important; padding: 0 !important; border: none !important; pointer-events: none !important;`;
                    const hermano = item.nextElementSibling;
                    if (hermano && hermano.tagName === 'HR') hermano.style.display = 'none';
                }
            } else {
                if (item.style.display === 'none') {
                    item.style.cssText = ''; 
                    const hermano = item.nextElementSibling;
                    if (hermano && hermano.tagName === 'HR') hermano.style.display = '';
                }
            }
        });
    }

    items.forEach(item => {
        if (item.innerText.includes(TEXTO_SORPRESA)) {
            if (item.querySelector('.opus-checkout-btn, .opus-btn-checkout, [name="checkout"]')) return;

            if (nivel3Alcanzado) {
                if (item.style.display !== 'none') {
                    item.style.cssText = `display: none !important; position: absolute !important; opacity: 0 !important; height: 0 !important; margin: 0 !important; padding: 0 !important; border: none !important; pointer-events: none !important;`;
                    const hermano = item.nextElementSibling;
                    if (hermano && hermano.tagName === 'HR') hermano.style.display = 'none';
                }
            } else {
                if (item.style.display === 'none') {
                    item.style.cssText = ''; 
                    const hermano = item.nextElementSibling;
                    if (hermano && hermano.tagName === 'HR') hermano.style.display = '';
                }
            }
        }
    });

    corregirContadores(window.itemsOcultosReales);
}

// --- 3. CORRECCIÓN DE BURBUJAS Y TÍTULOS ---
function corregirContadores(itemsOcultos) {
    const burbujas = document.querySelectorAll(`
        .cd-cart-count, .opus-cart-count, 
        .cart-count, .cart-count-bubble, [data-cart-count], #CartCount, 
        .header__cart-count, .site-header__cart-count, .cart-link__bubble,
        .site-header-cart--count, .header-cart-count, .cart-count-text, [data-header-cart-count]
    `);
    
    burbujas.forEach(badge => {
        let textoVisible = badge.innerText.trim();
        if (!/^\d*$/.test(textoVisible) && textoVisible !== "") return;
        
        let numVisible = parseInt(textoVisible) || 0;
        let fakeCount = parseInt(badge.getAttribute('data-fake-count'));
        
        if (numVisible !== fakeCount && textoVisible !== "") {
            badge.setAttribute('data-real-count', numVisible);
        }
        
        let realCount = parseInt(badge.getAttribute('data-real-count')) || numVisible;
        let nuevoValor = Math.max(0, realCount - itemsOcultos);
        
        if (numVisible !== nuevoValor) {
            badge.innerText = nuevoValor;
            badge.setAttribute('data-fake-count', nuevoValor);
        }
    });

    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null, false);
    let node;
    while ((node = walker.nextNode())) {
        let texto = node.nodeValue;
        if (/Tu carrito \(\d+\)/i.test(texto)) {
            let match = texto.match(/Tu carrito \((\d+)\)/i);
            if (match) {
                let parent = node.parentNode;
                if (parent.tagName === 'SCRIPT' || parent.tagName === 'STYLE') continue;

                let numVisible = parseInt(match[1]);
                let fakeCount = parseInt(parent.getAttribute('data-fake-count'));
                
                if (numVisible !== fakeCount) {
                    parent.setAttribute('data-real-count', numVisible);
                }
                
                let realCount = parseInt(parent.getAttribute('data-real-count')) || numVisible;
                let nuevoValor = Math.max(0, realCount - itemsOcultos);
                
                if (numVisible !== nuevoValor) {
                    node.nodeValue = texto.replace(/Tu carrito \(\d+\)/i, `Tu carrito (${nuevoValor})`);
                    parent.setAttribute('data-fake-count', nuevoValor);
                }
            }
        }
    }
}

// --- 4. REDIRECCIÓN Y PROCESAMIENTO FINAL ---
async function limpiarYRedirigir(botonOriginal, mensajeAutoGuardado = null) {
    try {
        if (botonOriginal) {
            if (botonOriginal.tagName.toLowerCase() === 'input') botonOriginal.value = "Procesando...";
            else botonOriginal.innerText = "Procesando...";
            botonOriginal.style.opacity = "0.7";
            botonOriginal.style.pointerEvents = "none";
        }

        const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js');
        const cart = await cartResponse.json();

        let payload = {};
        let updates = {};
        let necesitaActualizar = false;

        const todosLosPremium = cart.items.filter(item => 
            item.variant_id === ID_PREMIUM_CHECK || 
            item.product_id === ID_PREMIUM_CHECK ||
            item.title.includes(TEXTO_PREMIUM) ||
            item.product_title.includes(TEXTO_PREMIUM)
        );

        if (todosLosPremium.length > 0) {
            let indexToKeep = todosLosPremium.findIndex(item => item.price === 0);
            if (indexToKeep === -1) indexToKeep = 0; 

            todosLosPremium.forEach((item, index) => {
                if (index !== indexToKeep) {
                    updates[item.key] = 0;
                    necesitaActualizar = true;
                } else if (item.quantity > 1) {
                    updates[item.key] = 1;
                    necesitaActualizar = true;
                }
            });
        }

        const sorpresaItem = cart.items.find(item => item.variant_id === ID_SORPRESA_VARIANT);
        if (todosLosPremium.length > 0 && sorpresaItem) {
            updates[ID_SORPRESA_VARIANT] = 0; 
            necesitaActualizar = true;
        }

        Object.values(IDS_APORTE).forEach(id => {
            if(id !== 0) updates[id] = 0;
        });
        if (montoAporteSeleccionado > 0 && IDS_APORTE[montoAporteSeleccionado] !== 0) {
            updates[IDS_APORTE[montoAporteSeleccionado]] = 1;
            necesitaActualizar = true;
        }

        if (Object.keys(updates).length > 0) payload.updates = updates;

        if (mensajeAutoGuardado !== null) {
            payload.attributes = { 'Mensaje Tarjeta de Regalo': mensajeAutoGuardado };
            necesitaActualizar = true;
        } else {
            payload.attributes = { 'Mensaje Tarjeta de Regalo': '' };
            necesitaActualizar = true;
        }

        if (necesitaActualizar) {
            await fetch(window.Shopify.routes.root + 'cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            await new Promise(r => setTimeout(r, 200)); 
        }

        window.location.href = '/checkout';

    } catch (error) {
        console.error("Error al procesar, redirigiendo:", error);
        window.location.href = '/checkout';
    }
}

// --- 4.5 ALERTA PERSONALIZADA (TOAST BLINDADO) ---
function mostrarAlertaPersonalizada(titulo, mensaje, tipo = 'error') {
    const id = 'opus-toast-alerta';
    const existente = document.getElementById(id);
    if (existente) existente.remove();

    const bgColor = tipo === 'error' ? '#fee2e2' : '#dcfce7';
    const borderColor = tipo === 'error' ? '#dc2626' : '#16a34a';
    const textColor = tipo === 'error' ? '#991b1b' : '#166534';
    
    const iconSVG = tipo === 'error' 
        ? `<svg style="width: 18px; height: 18px; display: inline; vertical-align: text-bottom; margin-right: 4px;" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path></svg>`
        : `<svg style="width: 18px; height: 18px; display: inline; vertical-align: text-bottom; margin-right: 4px;" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path></svg>`;

    const alertaHTML = `
        <div id="${id}" style="
            position: fixed; top: 30px; right: 20px; background: ${bgColor}; color: ${textColor};
            padding: 16px 20px; border-radius: 8px; border-left: 4px solid ${borderColor};
            box-shadow: 0 10px 30px rgba(0,0,0,0.3); z-index: 2147483647; 
            font-family: inherit; font-size: 14px; display: flex; flex-direction: column; gap: 4px;
            animation: slideInToast 0.4s cubic-bezier(0.16, 1, 0.3, 1) forwards;
            max-width: 320px; pointer-events: none;
        ">
            <strong style="font-size: 15px; display: flex; align-items: center;">${iconSVG} ${titulo}</strong>
            <span style="opacity: 0.95;">${mensaje}</span>
        </div>
        <style>
            @keyframes slideInToast { from { transform: translateX(100%); opacity: 0; } to { transform: translateX(0); opacity: 1; } }
            @keyframes slideOutToast { from { transform: translateX(0); opacity: 1; } to { transform: translateX(120%); opacity: 0; } }
        </style>
    `;
    
    document.body.insertAdjacentHTML('beforeend', alertaHTML);
    const toast = document.getElementById(id);
    setTimeout(() => {
        if(toast) {
            toast.style.animation = 'slideOutToast 0.4s ease-in forwards';
            setTimeout(() => toast.remove(), 400);
        }
    }, 5500); 
}

// --- 4.6 PANTALLA DE GRACIAS CONDICIONAL ---
function crearModalGraciasAporte() {
    if (document.getElementById('modal-gracias-aporte-opus')) return;
    const modalHTML = `
        <style>
            #modal-gracias-aporte-opus {
                display: none; position: fixed !important; top: 0 !important; left: 0 !important; width: 100vw !important; height: 100vh !important;
                background: rgba(0, 0, 0, 0.6) !important; backdrop-filter: blur(4px) !important;
                z-index: 2147483647 !important; justify-content: center !important; align-items: center !important; font-family: inherit;
            }
            .modal-gracias-content {
                background: #ffffff !important; color: #5e5b5b !important; padding: 28px 24px !important; border-radius: 14px !important; width: 90% !important; max-width: 440px !important;
                box-shadow: 0 20px 40px rgba(0,0,0,0.2) !important; position: relative !important; text-align: left;
                animation: popInAporte 0.3s cubic-bezier(0.16, 1, 0.3, 1); border: 1px solid #e5e7eb;
            }
            @keyframes popInAporte { from { transform: scale(0.9); opacity: 0; } to { transform: scale(1); opacity: 1; } }
            .header-gracias { display: flex; flex-direction: column; align-items: center; margin-bottom: 24px; text-align: center; }
            .icono-corazon-gracias { width: 65px; height: 65px; background: #fff7ed; color: #f07e26; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 32px; margin: 0 auto 16px auto; border: 3px solid #fed7aa; animation: pulseHeart 1.5s infinite; }
            @keyframes pulseHeart { 0% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(240, 126, 38, 0.4); } 70% { transform: scale(1); box-shadow: 0 0 0 12px rgba(240, 126, 38, 0); } 100% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(240, 126, 38, 0); } }
            .header-gracias h3 { font-size: 22px !important; margin: 0 0 6px 0 !important; color: #5e5b5b !important; font-weight: 800 !important; }
            .header-gracias p { font-size: 14px !important; color: #5e5b5b !important; margin: 0 !important; }
            .summary-card { background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 10px; padding: 16px 20px; margin-bottom: 22px; text-align: left; }
            .summary-row { display: flex; justify-content: space-between; padding: 10px 0; font-size: 14px; color: #5e5b5b; border-bottom: 1px dashed #d1d5db; }
            .summary-row:last-child { border-bottom: none; }
            .summary-row.total { font-weight: 800; border-top: 2px solid #e5e7eb; padding-top: 14px; margin-top: 4px; font-size: 16px; }
            .texto-tablero { font-size: 13.5px !important; color: #5e5b5b !important; margin-bottom: 26px !important; text-align: center; }
            .redirect-loader { display: flex; flex-direction: column; align-items: center; gap: 10px; margin-top: 15px; }
            .spinner { border: 3px solid #f3f4f6; border-top: 3px solid #f07e26; border-radius: 50%; width: 24px; height: 24px; animation: spin 1s linear infinite; }
            @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
            .redirect-texto { font-size: 13.5px; color: #5e5b5b; font-weight: 600; }
        </style>
        <div id="modal-gracias-aporte-opus">
            <div class="modal-gracias-content">
                <div class="header-gracias">
                    <div class="icono-corazon-gracias">♥</div>
                    <h3>¡Tu pedido sumó a Chocó!</h3>
                    <p>Juntos estamos haciendo la diferencia.</p>
                </div>
                
                <div class="summary-card">
                    <div class="summary-row">
                        <span>1% de Tumatera</span>
                        <span id="resumen-1-por-ciento">$0</span>
                    </div>
                    <div class="summary-row">
                        <span>Tu aporte</span>
                        <span id="resumen-tu-aporte">$0</span>
                    </div>
                    <div class="summary-row total">
                        <span>Total a la fundación</span>
                        <span id="resumen-total-fundacion">$0</span>
                    </div>
                </div>

                <p class="texto-tablero">Ya está sumado al tablero público. <a href="https://site.tumatera.com/reconstruyamos-el-choco" target="_blank" style="color:#f07e26; font-weight: 600; text-decoration: none;">Mira en qué se convierte.</a></p>

                <div class="redirect-loader">
                    <div class="spinner"></div>
                    <span class="redirect-texto">Llevándote al pago seguro...</span>
                </div>
            </div>
        </div>
    `;
    document.body.insertAdjacentHTML('beforeend', modalHTML);
}

function mostrarModalGraciasYRedirigir(botonOriginal, mensajeAutoGuardado) {
    crearModalGraciasAporte();
    
    document.getElementById('resumen-1-por-ciento').innerText = `$${Math.round(globalUnoPorCiento).toLocaleString('es-CO')}`;
    document.getElementById('resumen-tu-aporte').innerText = `$${montoAporteSeleccionado.toLocaleString('es-CO')}`;
    document.getElementById('resumen-total-fundacion').innerText = `$${Math.round(globalTotalFundacion).toLocaleString('es-CO')}`;
    
    const modal = document.getElementById('modal-gracias-aporte-opus');
    modal.style.setProperty('display', 'flex', 'important');
    
    setTimeout(() => {
        limpiarYRedirigir(botonOriginal, mensajeAutoGuardado);
    }, 2000);
}


// --- 5. DETECTOR ROBUSTO Y EVENTOS (CON MEMORIA DE ESTADO) ---
function isRegaloActivo() {
    if (document.querySelector('.cd-toggle-switch.bg-active, .cd-toggle-switch.active, .cd-toggle-switch.is-active')) return true;
    const toggle = document.querySelector('.cd-toggle-switch');
    if (toggle) {
        const inputInterno = toggle.querySelector('input[type="checkbox"]');
        if (inputInterno && inputInterno.checked) return true;
    }
    const checkboxes = document.querySelectorAll('input[type="checkbox"]:checked');
    for (let cb of checkboxes) {
        let containerText = cb.closest('div, label, li, .cd-special-instructions-header')?.innerText?.toLowerCase() || '';
        if (containerText.includes('regalo') || containerText.includes('tarjeta')) {
            return true;
        }
    }
    return false;
}

function abrirModalYEnfocar() {
    crearModalRegalo(); 
    const modal = document.getElementById('modal-regalo-opus');
    if (modal) {
        modal.style.setProperty('display', 'flex', 'important');
        document.getElementById('estado-formulario').style.setProperty('display', 'block', 'important');
        document.getElementById('estado-exito').style.setProperty('display', 'none', 'important');
        
        setTimeout(() => {
            const inputDe = document.getElementById('regalo-de');
            if (inputDe && window.innerWidth > 768) {
                inputDe.focus();
            }
        }, 150);
    }
}

let estadoTogglePrevio = false;
document.addEventListener('mousedown', () => { estadoTogglePrevio = isRegaloActivo(); }, true);
document.addEventListener('touchstart', () => { estadoTogglePrevio = isRegaloActivo(); }, { passive: true, capture: true });

document.addEventListener('click', function(e) {
    const targetCheckout = e.target.closest('.opus-btn-checkout, .opus-checkout-btn, .cd-checkout-btn, [name="checkout"], button.cart__checkout, .cart-drawer__checkout, a[href="/checkout"], form[action="/cart"] button[type="submit"], form[action="/cart"] input[type="submit"]');
    
    if (e.target.closest('#modal-regalo-opus') || e.target.closest('#inline-aporte-opus') || e.target.closest('#modal-gracias-aporte-opus')) return;

    if (targetCheckout) {
        let mensajeFinalParaGuardar = null;
        
        if (isRegaloActivo()) {
            crearModalRegalo(); 
            const de = document.getElementById('regalo-de') ? document.getElementById('regalo-de').value.trim() : '';
            const para = document.getElementById('regalo-para') ? document.getElementById('regalo-para').value.trim() : '';
            const msj = document.getElementById('regalo-mensaje') ? document.getElementById('regalo-mensaje').value.trim() : '';

            if (!de || !para || !msj) {
                e.preventDefault();
                e.stopImmediatePropagation(); 
                
                abrirModalYEnfocar();
                
                setTimeout(() => {
                    mostrarAlertaPersonalizada("Información requerida", "Seleccionaste la opción mensaje personalizado pero no llenaste la tarjeta con la información para tu mensaje.", 'error');
                }, 50);
                
                setTimeout(() => {
                    if (window.innerWidth > 768) {
                        if(!de) document.getElementById('regalo-de').focus();
                        else if(!para) document.getElementById('regalo-para').focus();
                        else document.getElementById('regalo-mensaje').focus();
                    }
                }, 200);
                return false; 
            }
            mensajeFinalParaGuardar = `De: ${de} | Para: ${para} | Mensaje: ${msj}`;
        }

        e.preventDefault();
        e.stopImmediatePropagation();
        
        // REDIRECCIÓN CONDICIONAL SEGÚN EL APORTE
        if (montoAporteSeleccionado > 0) {
            mostrarModalGraciasYRedirigir(targetCheckout, mensajeFinalParaGuardar);
        } else {
            limpiarYRedirigir(targetCheckout, mensajeFinalParaGuardar);
        }
        return false;
    }
    
    const toggleClickeado = e.target.closest('.cd-toggle-switch, .cd-toggle-switch-slider, label');
    if (toggleClickeado) {
        setTimeout(() => {
            if (!estadoTogglePrevio && isRegaloActivo()) {
                abrirModalYEnfocar();
            }
        }, 300); 
    }
}, true);

document.addEventListener('change', function(e) {
    if (e.target.type === 'checkbox') {
        setTimeout(() => {
            if (e.target.checked && isRegaloActivo()) abrirModalYEnfocar();
        }, 100);
    }
});

// --- 6. BLOQUE INLINE DE APORTE (ACTUALIZADO EN TIEMPO REAL) ---
async function inyectarBloqueAporte() {
    const checkoutBtns = document.querySelectorAll('.opus-btn-checkout, .opus-checkout-btn, .cd-checkout-btn, [name="checkout"]');
    if (checkoutBtns.length === 0) return;

    const btnVisible = Array.from(checkoutBtns).find(b => b.offsetWidth > 0 || b.offsetHeight > 0);
    if (!btnVisible) return;

    let cart, subtotalSinDonacion;
    try {
        const res = await fetch(window.Shopify.routes.root + 'cart.js');
        cart = await res.json();
        subtotalSinDonacion = cart.items.reduce((total, item) => {
            if (Object.values(IDS_APORTE).includes(item.variant_id)) {
                let key = Object.keys(IDS_APORTE).find(k => IDS_APORTE[k] === item.variant_id);
                if (key && montoAporteSeleccionado === 0) montoAporteSeleccionado = parseInt(key);
                return total;
            }
            return total + item.original_line_price;
        }, 0) / 100;
    } catch (e) {
        return; 
    }

    if (subtotalSinDonacion <= 0) {
        const bloque = document.getElementById('inline-aporte-opus');
        if (bloque) bloque.remove();
        return; 
    }

    const blockExists = document.getElementById('inline-aporte-opus');
    
    if (blockExists && subtotalSinDonacion === ultimoSubtotalAporte) {
        if (blockExists.nextElementSibling !== btnVisible) {
            btnVisible.insertAdjacentElement('beforebegin', blockExists);
        }
        return;
    }

    ultimoSubtotalAporte = subtotalSinDonacion;
    globalUnoPorCiento = subtotalSinDonacion * 0.01;

    let montos = [];
    if (subtotalSinDonacion < 50000) {
        montos = [2000, 5000, 10000];
    } else if (subtotalSinDonacion <= 150000) {
        montos = [5000, 10000, 20000];
    } else {
        montos = [10000, 20000, 50000];
    }

    if (montoAporteSeleccionado !== 0 && !montos.includes(montoAporteSeleccionado)) {
        montoAporteSeleccionado = 0;
    }

    // Se restaura el H3 exacto: "Suma tu aporte a Chocó."
    const htmlInline = `
        <div id="inline-aporte-opus" style="background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 10px; padding: 15px; margin-bottom: 15px; text-align: center; width: 100%; box-sizing: border-box; font-family: inherit; clear: both;">
            <h4 style="margin: 0 0 6px 0; color: #5e5b5b; font-size: 15px; font-weight: 800;">Suma tu aporte a Chocó.</h4>
            <p style="font-size: 13px; color: #5e5b5b; margin: 0 0 12px 0; line-height: 1.35;">Tumatera ya pone el 1% de esta compra. Si quieres, agrega el tuyo.</p>
            
            <div style="display: flex; gap: 6px; margin-bottom: 12px; flex-wrap: wrap; justify-content: center;" id="grupo-botones-aporte-inline">
                <button class="inline-aporte-btn ${montoAporteSeleccionado === 0 ? 'activo' : ''}" data-monto="0" style="flex: 1; min-width: 70px; padding: 10px 4px; background: ${montoAporteSeleccionado === 0 ? '#f07e26' : '#ffffff'}; color: ${montoAporteSeleccionado === 0 ? '#ffffff' : '#5e5b5b'}; border: 1px solid ${montoAporteSeleccionado === 0 ? '#f07e26' : '#d1d5db'}; border-radius: 6px; cursor: pointer; font-size: 12px; font-weight: 700; transition: all 0.2s;">No, gracias</button>
                ${montos.map(m => `
                    <button class="inline-aporte-btn ${montoAporteSeleccionado === m ? 'activo' : ''}" data-monto="${m}" style="flex: 1; min-width: 70px; padding: 10px 4px; background: ${montoAporteSeleccionado === m ? '#f07e26' : '#ffffff'}; color: ${montoAporteSeleccionado === m ? '#ffffff' : '#5e5b5b'}; border: 1px solid ${montoAporteSeleccionado === m ? '#f07e26' : '#d1d5db'}; border-radius: 6px; cursor: pointer; font-size: 12px; font-weight: 700; transition: all 0.2s;">$${m.toLocaleString('es-CO')}</button>
                `).join('')}
            </div>

            <div id="inline-aporte-dinamico" style="font-size: 13px; color: #5e5b5b; line-height: 1.45; text-align: center;"></div>
        </div>
    `;

    if (blockExists) blockExists.remove();
    btnVisible.insertAdjacentHTML('beforebegin', htmlInline);

    const botones = document.querySelectorAll('.inline-aporte-btn');
    botones.forEach(btn => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            montoAporteSeleccionado = parseInt(btn.dataset.monto);
            
            botones.forEach(b => {
                b.style.background = '#ffffff';
                b.style.color = '#5e5b5b';
                b.style.borderColor = '#d1d5db';
                b.classList.remove('activo');
            });

            btn.style.background = '#f07e26';
            btn.style.color = '#ffffff';
            btn.style.borderColor = '#f07e26';
            btn.classList.add('activo');

            actualizarCalculoInline();
        });
    });

    actualizarCalculoInline();
}

function actualizarCalculoInline() {
    const divDinamico = document.getElementById('inline-aporte-dinamico');
    if (!divDinamico) return;

    globalTotalFundacion = globalUnoPorCiento + montoAporteSeleccionado;

    // Se restauran los textos originales exactos con sus clases y etiquetas 'strong'
    if (montoAporteSeleccionado === 0) {
        divDinamico.innerHTML = `Sin problema. Tu compra igual aporta <strong style="color:#f07e26;">$${Math.round(globalUnoPorCiento).toLocaleString('es-CO')}</strong> por el 1% de Tumatera.`;
    } else {
        let textoImpacto = '';
        const costoBulto = 38000;
        const costoLadrillo = 1800;
        
        if (globalTotalFundacion < costoBulto) {
            let numeroLadrillos = Math.floor(globalTotalFundacion / costoLadrillo);
            textoImpacto = `${numeroLadrillos} ladrillo${numeroLadrillos !== 1 ? 's' : ''}`;
        } else {
            let bultosEnteros = Math.floor(globalTotalFundacion / costoBulto);
            let saldoRestante = globalTotalFundacion % costoBulto; 
            let ladrillosRestantes = Math.floor(saldoRestante / costoLadrillo);
            
            let textoBultos = `${bultosEnteros} bulto${bultosEnteros !== 1 ? 's' : ''} de cemento`;
            
            if (ladrillosRestantes > 0) {
                let textoLadrillos = `${ladrillosRestantes} ladrillo${ladrillosRestantes !== 1 ? 's' : ''}`;
                textoImpacto = `${textoBultos} y ${textoLadrillos}`;
            } else {
                textoImpacto = textoBultos; 
            }
        }

        divDinamico.innerHTML = `Entre tu aporte y el 1% de Tumatera, esta compra manda $${Math.round(globalTotalFundacion).toLocaleString('es-CO')} a Chocó. Alcanza para <strong style="color:#f07e26;">${textoImpacto}</strong> entregados en Chocó.`;
    }
}

// --- 7. TEXTO INFORMATIVO (Impuestos) ---
function insertarTexto() {
    const botones = document.querySelectorAll('.opus-btn-checkout, .opus-checkout-btn, .cd-checkout-btn, [name="checkout"]');
    botones.forEach(boton => {
        if (!boton.dataset.textoInsertado) {
             const texto = `<div class="opus-extra-text" style="width:100%; clear:both; text-align:center; font-size: 0.85em; margin-top: 8px; line-height: 1.2; color: #5e5b5b;">Impuesto incluido. Los <a href="https://tumatera.co/pages/transporte-envio-gratis" target="_blank" style="color:#f07e26;text-decoration:underline;">gastos de envío</a> se calculan al pagar.</div>`;
             try {
                boton.insertAdjacentHTML("afterend", texto);
                boton.dataset.textoInsertado = "true";
             } catch (e) {}
        }
    });
}

// --- 8. LÓGICA DE TARJETA DE REGALO E INSTRUCCIONES ---
function crearModalRegalo() {
    if (document.getElementById('modal-regalo-opus')) return; 

    const modalHTML = `
        <style>
            #modal-regalo-opus {
                display: none; position: fixed !important; top: 0 !important; left: 0 !important; width: 100vw !important; height: 100vh !important;
                background: rgba(0, 0, 0, 0.6) !important; backdrop-filter: blur(4px) !important;
                z-index: 2147483647 !important; 
                justify-content: center !important; align-items: center !important;
                font-family: inherit;
            }
            .modal-regalo-content {
                background: #ffffff !important; padding: 30px !important; border-radius: 12px !important; width: 90% !important; max-width: 450px !important;
                box-shadow: 0 20px 40px rgba(0,0,0,0.3) !important; position: relative !important;
                z-index: 2147483647 !important;
                animation: modalSlideIn 0.3s cubic-bezier(0.16, 1, 0.3, 1);
            }
            @keyframes modalSlideIn { from { transform: translateY(30px) scale(0.95); opacity: 0; } to { transform: translateY(0) scale(1); opacity: 1; } }
            .modal-regalo-content h3 { margin: 0 0 8px 0; color: #5e5b5b; font-size: 22px; font-weight: 600; text-align: center; }
            .modal-regalo-content p { font-size: 14px; color: #4b5563; margin-bottom: 20px; line-height: 1.5; text-align: center; }
            .opus-input-group { display: flex; flex-direction: column; margin-bottom: 15px; text-align: left; }
            .opus-input-group label { font-size: 13px; font-weight: 600; color: #4b5563; margin-bottom: 5px; }
            .opus-input-control { width: 100%; box-sizing: border-box; padding: 12px; border: 1px solid #e5e7eb; border-radius: 8px; font-size: 14px; color: #333; background-color: #f9fafb; transition: all 0.2s ease; font-family: inherit; }
            textarea.opus-input-control { resize: none; }
            .opus-input-control:focus { outline: none; border-color: #f07e26; background-color: #ffffff; box-shadow: 0 0 0 3px rgba(240, 126, 38, 0.15); }
            .modal-regalo-actions { display: flex; justify-content: space-between; gap: 12px; margin-top: 20px; }
            .btn-modal-regalo { flex: 1; padding: 12px; border: none; border-radius: 8px; font-weight: 600; font-size: 15px; cursor: pointer; transition: all 0.2s ease; }
            .btn-modal-cancelar { background: #f3f4f6; color: #4b5563; }
            .btn-modal-cancelar:hover { background: #e5e7eb; color: #1f2937; }
            .btn-modal-guardar { background: #f07e26; color: #ffffff; }
            .btn-modal-guardar:hover { background: #e06c15; box-shadow: 0 4px 12px rgba(240, 126, 38, 0.3); }
            .btn-modal-close-icon { position: absolute; top: 15px; right: 15px; background: none; border: none; font-size: 24px; color: #9ca3af; cursor: pointer; padding: 0; line-height: 1; }
            .btn-modal-close-icon:hover { color: #4b5563; }
            #estado-exito { display: none; text-align: center; padding: 30px 0; animation: modalSlideIn 0.4s ease; }
            .success-checkmark { width: 60px; height: 60px; background: #dcfce7; color: #16a34a; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 30px; margin: 0 auto 15px auto; animation: popIn 0.5s cubic-bezier(0.16, 1, 0.3, 1); }
            @keyframes popIn { 0% { transform: scale(0); } 80% { transform: scale(1.1); } 100% { transform: scale(1); } }
        </style>

        <div id="modal-regalo-opus">
            <div class="modal-regalo-content">
                <button class="btn-modal-close-icon" id="cerrar-modal-x">&times;</button>
                
                <div id="estado-formulario">
                    <h3>Tarjeta de Regalo</h3>
                    <p>Escribe el mensaje que acompañará tu pedido.</p>
                    
                    <div class="opus-input-group">
                        <label for="regalo-de">De:</label>
                        <input type="text" id="regalo-de" class="opus-input-control" placeholder="Tu nombre">
                    </div>
                    
                    <div class="opus-input-group">
                        <label for="regalo-para">Para:</label>
                        <input type="text" id="regalo-para" class="opus-input-control" placeholder="Nombre de la persona">
                    </div>
                    
                    <div class="opus-input-group">
                        <label for="regalo-mensaje">Mensaje:</label>
                        <textarea id="regalo-mensaje" class="opus-input-control" rows="3" placeholder="Escribe tus mejores deseos..."></textarea>
                    </div>

                    <div class="modal-regalo-actions">
                        <button class="btn-modal-regalo btn-modal-cancelar" id="cerrar-modal-regalo">Cancelar</button>
                        <button class="btn-modal-regalo btn-modal-guardar" id="guardar-mensaje-regalo">Guardar Mensaje</button>
                    </div>
                </div>

                <div id="estado-exito">
                    <div class="success-checkmark">✓</div>
                    <h3>¡Mensaje Guardado!</h3>
                    <p>Tu tarjeta de regalo está lista para enviarse.</p>
                </div>
            </div>
        </div>
    `;

    document.body.insertAdjacentHTML('beforeend', modalHTML);

    const cerrarModal = () => { document.getElementById('modal-regalo-opus').style.setProperty('display', 'none', 'important'); };
    
    document.getElementById('cerrar-modal-regalo').addEventListener('click', cerrarModal);
    document.getElementById('cerrar-modal-x').addEventListener('click', cerrarModal);

    document.getElementById('guardar-mensaje-regalo').addEventListener('click', async () => {
        const de = document.getElementById('regalo-de').value.trim();
        const para = document.getElementById('regalo-para').value.trim();
        const msj = document.getElementById('regalo-mensaje').value.trim();
        
        if (!de || !para || !msj) {
            mostrarAlertaPersonalizada("Atención", "Todos los campos son obligatorios para la tarjeta de regalo.");
            if (window.innerWidth > 768) {
                if(!de) document.getElementById('regalo-de').focus();
                else if(!para) document.getElementById('regalo-para').focus();
                else document.getElementById('regalo-mensaje').focus();
            }
            return;
        }

        const mensajeFinal = `De: ${de} | Para: ${para} | Mensaje: ${msj}`;
        const btn = document.getElementById('guardar-mensaje-regalo');
        const originalText = btn.innerText;
        btn.innerText = "Guardando...";
        btn.style.opacity = "0.7";
        btn.style.pointerEvents = "none";
        
        try {
            await fetch(window.Shopify.routes.root + 'cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ attributes: { 'Mensaje Tarjeta de Regalo': mensajeFinal } })
            });
            
            document.getElementById('estado-formulario').style.display = 'none';
            document.getElementById('estado-exito').style.display = 'block';
            
            setTimeout(() => { cerrarModal(); }, 2000);

        } catch (e) {
            console.error("Error guardando mensaje", e);
            mostrarAlertaPersonalizada("Aviso", "Parece que hay intermitencia, pero validaremos tu mensaje al pagar.", "error");
            setTimeout(() => { cerrarModal(); }, 1500);
        } finally {
            btn.innerText = originalText;
            btn.style.opacity = "1";
            btn.style.pointerEvents = "auto";
        }
    });
}

function forzarInstruccionesAbiertas() {
    const headers = document.querySelectorAll('.cd-special-instructions-header');
    headers.forEach(header => {
        if (!header.classList.contains('cd-special-instructions-header-active')) {
            header.classList.add('cd-special-instructions-header-active');
        }
        const content = header.nextElementSibling;
        if (content) {
            content.style.setProperty('display', 'block', 'important');
            content.style.setProperty('position', 'relative', 'important'); 
            content.style.setProperty('background-color', '#ffffff', 'important'); 
            content.style.setProperty('margin-bottom', '20px', 'important'); 
            content.style.setProperty('z-index', '1', 'important');
            content.style.setProperty('height', 'auto', 'important');
            content.style.setProperty('visibility', 'visible', 'important');
            content.style.setProperty('clear', 'both', 'important');
            content.style.setProperty('opacity', '1', 'important');
        }
    });
}

// --- 9. EJECUCIÓN INMEDIATA Y CONTINUA ---
if (window.itemsOcultosReales > 0) corregirContadores(window.itemsOcultosReales);

document.addEventListener("DOMContentLoaded", () => {
    corregirContadores(window.itemsOcultosReales);
    crearModalRegalo();
    crearModalGraciasAporte(); 
    inyectarBloqueAporte();
});

// Intervalos combinados
setInterval(sincronizarConBackend, 2500); 
setInterval(gestionarVisibilidadRegalos, 100);
setInterval(forzarInstruccionesAbiertas, 500);
setInterval(insertarTexto, 1500);
setInterval(inyectarBloqueAporte, 1000); 
setInterval(crearModalGraciasAporte, 2000);